// combatpro/views/SelectionView.js
//
// Stage 33: view-selection shell, moved verbatim out of CombatProEngineApp.js.
//
// Stage 66 (Selection View Foundation): the legacy Selection page (battletracker.html
// 3654-3682) is entirely static - three instructional cards plus an empty
// #view-selection-panel that the legacy never populates (no getElementById, no
// innerHTML, no render path writes into it; the actual monster selection happens via
// the header dropdowns owned by the Stage 61 selection runtime, not this page). This
// stage retires the Stage 33 placeholder that rendered state.selectionItems into the
// panel (a Stage 20 empty-placeholder array with no legacy counterpart), so the panel
// is the empty container the legacy actually has. With the placeholder gone the view
// reads no state, so the CombatContext import and the useContext hook are removed.
// The three instructional cards are unchanged. No runtime is touched, no CombatContext
// change, no new behaviour, no Stage 57/61/62 wiring (the legacy page never interacted
// with them).

import React from 'react';
import CombatOpsPanel from '../runtime/CombatOpsPanel';

function SelectionView() {
  return (
    <div className="vi-view" id="view-selection">
      <div className="vi-view-notice">
        <div className="vi-selection-cards">
          <div className="vi-selection-card">
            <div className="vi-card-title">How to Use</div>
            <div className="vi-howto-steps">
              <p>Go to the Monsters dropdown selection above.</p>
              <p>Select a monster by clicking its tab.</p>
              <p>Your selection will then display below to edit that monster's full configuration.</p>
            </div>
          </div>
          <div className="vi-selection-card">
            <div className="vi-card-title">What Happens</div>
            <p>All monster data is loaded into the system including stats, abilities, and combat settings.</p>
            <p>Sections like Ability Scores, Morale, and Combat update automatically based on the selected monster.</p>
            <p>You can edit any values to customise behaviour or difficulty.</p>
          </div>
          <div className="vi-selection-card">
            <div className="vi-card-title">Important</div>
            <p>You are always editing the currently selected monster.</p>
            <p>If no monster is selected, no active data will be shown.</p>
          </div>
        </div>
      </div>
      <div id="view-selection-panel"><CombatOpsPanel /></div>
    </div>
  );
}

export default SelectionView;
